import { AssetOwnershipMeta } from '/@/modules/asset/models/meta/AssetOwnershipMeta';

export class LandAssetMeta extends AssetOwnershipMeta {
  sharePercentage?: number;
  propertyIdentificationNumber?: string;
  rollNumber?: string;
  types?: Array<string>;
  legalDescription?: string;
  hasAddress?: boolean;
  incomeDescription?: string;
  hasIncome?: boolean;

  constructor(model: Partial<LandAssetMeta> = {}) {
    super(model);

    this.types = model.types;
    this.propertyIdentificationNumber = model.propertyIdentificationNumber;
    this.rollNumber = model.rollNumber;
    this.sharePercentage = model.sharePercentage;
    this.legalDescription = model.legalDescription;
    this.hasAddress = model.hasAddress;
    this.incomeDescription = model.incomeDescription;
    this.hasIncome = model.hasIncome;
  }
}
